import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';
import { ListVehiclesRequest } from '../../components/ListVehicles/components/ListVehiclesRow/types';

export type ActiveItem = ListVehiclesRequest & {
  dayNumber?: number;
  orderIndex?: number;
};

type DraggableState = {
  activeItem: ActiveItem | null;
  activeItemType: 'seller-block' | null;
};

type ListVehiclesState = {
  isVehiclePoolModalOpen: boolean;
  rightPanelExpanded: boolean;
  draggableState: DraggableState;
  selectedItemInPool: ListVehiclesRequest | null;
};

const initialState: ListVehiclesState = {
  isVehiclePoolModalOpen: false,
  rightPanelExpanded: false,
  draggableState: {
    activeItem: null,
    activeItemType: null
  },
  selectedItemInPool: null
};

const listVehiclesSlice = createSlice({
  name: 'listVehicles',
  initialState,
  reducers: {
    openVehiclePoolModal: state => {
      state.isVehiclePoolModalOpen = true;
    },
    closeVehiclePoolModal: state => {
      state.isVehiclePoolModalOpen = false;
    },
    setDraggableItem: (state, action: PayloadAction<ActiveItem>) => {
      state.draggableState.activeItem = action.payload;
      state.draggableState.activeItemType = 'seller-block';
    },
    clearDraggableItem: state => {
      state.draggableState = {
        activeItem: null,
        activeItemType: null
      };
    },
    toggleRightPanel: state => {
      state.rightPanelExpanded = !state.rightPanelExpanded;
    },
    setSelectedItemInPool: (state, action: PayloadAction<ListVehiclesRequest>) => {
      state.selectedItemInPool = action.payload;
    },
    clearSelectedItemInPool: state => {
      state.selectedItemInPool = null;
    }
  }
});

export const useIsPoolModalOpen = (): boolean => {
  const isOpen = useSelector((state: any) => state.listVehicles.isVehiclePoolModalOpen);
  return isOpen;
};

export const useIsRightPanelExpanded = (): boolean => {
  const isExpanded = useSelector((state: any) => state.listVehicles.rightPanelExpanded);
  return isExpanded;
};

export const useGetDraggableItem = () => {
  const item = useSelector<{ listVehicles: ListVehiclesState }, DraggableState>(
    state => state.listVehicles.draggableState
  );

  return item.activeItem;
};

export const useGetSelectedRequest = (): ListVehiclesRequest | null => {
  const id = useSelector((state: any) => state.listVehicles.selectedItemInPool);
  return id;
};

export const {
  openVehiclePoolModal,
  closeVehiclePoolModal,
  toggleRightPanel,
  setDraggableItem,
  clearDraggableItem,
  setSelectedItemInPool,
  clearSelectedItemInPool
} = listVehiclesSlice.actions;
export default listVehiclesSlice;
